import React, { ReactElement } from 'react';

export const MaterialIntegrityQuickGuide = (): ReactElement => {
	return <></>;
};
